import { LAYER_NAMES } from './layerNames';

const LAYER_ORDER = [
	//BOTTOM
	LAYER_NAMES.CHOROPLETH_STATE_LAYER,
	LAYER_NAMES.CHOROPLETH_COUNTRY_LAYER,
	LAYER_NAMES.STATE_OUTLINE_LAYER,
	LAYER_NAMES.COUNTRY_OUTLINE_LAYER,
	'country-label',
	//TOP
];

export default LAYER_ORDER;
